import { Info } from 'lucide-react';

/**
 * Oct 2026 — DECLARED / ESTIMATED pill for next ex-div & pay dates, shared by
 * the "Is X a dividend stock", "X ex-dividend date" and /stock/:t pages so
 * they badge the upcoming payment exactly like the Stock Modal's Next
 * Payment card. `next` is the backend `next_schedule` object.
 */
export function DeclaredPill({ declared, testId = 'declared-pill', className = '' }) {
  if (declared == null) return null;
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wide ${declared
        ? 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300'
        : 'bg-amber-500/15 text-amber-700 dark:text-amber-300'} ${className}`}
      title={declared
        ? 'Declared — the issuer has published this date and amount.'
        : 'Estimated — projected from the issuer\'s past schedule; not yet declared.'}
      data-testid={testId}
    >
      {declared ? 'Declared' : 'Estimated'}
    </span>
  );
}

export function EstimateDisclaimer({ next, testId = 'estimate-disclaimer', className = '' }) {
  if (!next || next.declared) return null;
  const cycles = next.based_on_cycles;
  return (
    <p className={`flex items-start gap-1.5 text-[11px] leading-snug text-amber-800/90 dark:text-amber-300/90 ${className}`} data-testid={testId}>
      <Info className="w-3.5 h-3.5 shrink-0 mt-px" />
      <span>
        <strong>Estimated, not declared.</strong> The next ex-dividend date, payment date and amount are projected from the
        issuer&apos;s past schedule{cycles ? ` (${cycles} past ${cycles === 1 ? 'cycle' : 'cycles'})` : ''} and may be wrong —
        the issuer can change the date, the amount, or skip the payment. Confirm the official declaration before buying to
        capture a dividend. This is information, not buying advice; it updates automatically once the issuer declares.
      </span>
    </p>
  );
}
